module.exports = __webpack_public_path__ + "img/r250.7850d65c.png";